import { gql } from '@apollo/client'

export const JOIN_MEETING = gql`
  mutation JoinMeeting($appointmentId: ID!) {
    appointment: joinMeeting(appointmentId: $appointmentId) {
      id
      conversationId
      from
      to
      chimeAttendeeData
      chimeMeetingData
      timeStatus
      hasInterlocutorJoined
      interlocutor {
        firstName
        lastName
        avatar
        phone
      }
      me {
        firstName
        lastName
        avatar
      }
    }
  }
`

export const LEAVE_MEETING = gql`
  mutation LeaveMeeting($appointmentId: ID!) {
    leaveMeeting(appointmentId: $appointmentId)
  }
`

export const UPDATE_CHIME_RATING = gql`
  mutation UpdateChimeRating($appointmentId: ID!, $rating: Int!) {
    updateChimeRating(appointmentId: $appointmentId, rating: $rating) {
      id
    }
  }
`
